<template>
  <div class="flex-container">
    <div class="flex-item-4"></div>
    <div class="flex-item-4">
      <div class="small-box" style="color: #333 !important; background-color: white">
        <div class="inner">
          <h3 class="text-right">{{ t('Estatísticas') }}</h3>
          <table class="table table-condensed table-hover table-striped">
            <tbody>
              <tr>
                <td style="width: 50%; text-align: right">{{ t('Países') }}:</td>
                <td>{{ stats.paises }}</td>
              </tr>
              <tr>
                <td style="text-align: right">{{ t('Cidades') }}:</td>
                <td>{{ stats.cidades }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="flex-item-4"></div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

interface FranquiasStats {
  paises: number;
  cidades: number;
  estados: number;
  idiomas: number;
}

interface Props {
  stats?: FranquiasStats;
}

withDefaults(defineProps<Props>(), {
  stats: () => ({
    paises: 0,
    cidades: 0,
    estados: 0,
    idiomas: 0,
  }),
});

// Get i18n composable
const { t } = useI18n();
</script>

<style scoped>
.small-box {
  border-radius: 2px;
  position: relative;
  display: block;
  margin-bottom: 20px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  padding: 10px;
  border: 1px solid #d2d6de;
}

.small-box .inner {
  padding: 10px;
}

.table-condensed > thead > tr > th,
.table-condensed > tbody > tr > th,
.table-condensed > tfoot > tr > th,
.table-condensed > thead > tr > td,
.table-condensed > tbody > tr > td,
.table-condensed > tfoot > tr > td {
  padding: 5px;
}

.text-right {
  text-align: right;
}
</style>
